<template>
  <JobEditor
    v-if="ready"
    is-template
    class="job-template-editor"
    :is-edit-mode="isEditMode"
    :value="jobTemplateInfo"
    @cancel="handleCancel"
    @save="handleSave"
    @save-back="handleSaveAndBack"
  />
</template>

<script>
import { mapActions } from 'vuex'
import JobEditor from '@/components/job/editor/layout.vue'

export default {
  components: {
    JobEditor
  },
  data () {
    return {
      ready: false,
      readyPromise: [],
      jobTemplateInfo: {}
    }
  },
  computed: {
    isEditMode () {
      return this.$route.meta.isEditMode
    },
    jobTemplateId () {
      return this.$route.params.jobTemplateId
    }
  },
  created () {
    if (this.isEditMode) {
      this.readyPromise.push(this.getJobTemplateInfo())
    }
    Promise.all(this.readyPromise).then(() => {
      this.ready = true
    })
  },
  methods: {
    ...mapActions('jobTemplate', ['getJobTemplateById', 'createJobTemplate', 'updateJobTemplate']),
    async getJobTemplateInfo () {
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.getJobTemplateById(this.jobTemplateId)
        if (resp && resp.result) {
          this.jobTemplateInfo = resp.result
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async handleCancel () {
      this.$router.push('/v-admin/job-template/management/list')
    },
    async handleSave (jobTemplateInfo, autoBack) {
      this.$eventBus.$emit('showLoading', true)
      try {
        let saveFunc = this.createJobTemplate
        let data = jobTemplateInfo
        if (this.isEditMode) {
          data = {
            templateId: jobTemplateInfo.id,
            data: data
          }
          saveFunc = this.updateJobTemplate
        }
        const resp = await saveFunc(data)
        if (resp) {
          this.$message.success(this.$t('common.message.saveSuccess'))
          if (autoBack) {
            this.$router.push('/v-admin/job-template/management/list')
          }
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    handleSaveAndBack (jobTemplateInfo) {
      return this.handleSave(jobTemplateInfo, true)
    }
  }
}
</script>

<style lang="scss" scoped>
.job-template-editor {
  min-width: 1345px;
  overflow: auto;
}
</style>
